<template>
  <div class="special__goods">
    <div class="special__goods__title">
      <img class="logo" src="@/assets/store/special-price.png" />
      <el-button @click="$emit('click-more')" plain class="special__goods__title__more">
        查看更多
        <i class="el-icon-arrow-right"></i>
      </el-button>
    </div>
    <div class="special__goods__list">
      <SlideWrap v-if="goodsList.length">
        <GoodsInfo
          mini
          class="pointer"
          v-for="goods in goodsList"
          :key="goods.itemCode"
          :hideIcon="false"
          @update-cart="$emit('update-cart')"
          :goods="goods"
          :itemStyle="itemStyle"
          :imgStyle="imgStyle"
          :purchaseAble="true"
          itemType="store"
          @click-goods="linkToGoodsDetails(goods.itemCode)"
        />
      </SlideWrap>
    </div>
  </div>
</template>

<script>
import SlideWrap from '@/components/SlideWrap';
import GoodsInfo from '@/components/GoodsInfo';
export default {
  props: {
    goodsList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    SlideWrap,
    GoodsInfo
  },
  data() {
    return {
      itemStyle: {
        width: '219px',
        border: '1px solid #D9D9D9',
        margin: '0 8px 16px 8px',
        marginBottom: '16px'
      },
      imgStyle: {
        width: '195px',
        height: '195px'
      }
    };
  },
  methods: {
    linkToGoodsDetails(id) {
      this.$router.push({ path: `/goodsDetails/${id}` });
    }
  }
};
</script>

<style lang="scss" scoped>
.special__goods {
  margin-top: 16px;
  padding: 32px 28px;
  background-color: #ffffff;
  .logo {
    width: 320px;
    height: 32px;
  }
  &__title {
    position: relative;
    text-align: center;
    &__more {
      position: absolute;
      right: 0;
      bottom: 0;
      font-size: 14px;
      font-weight: 400;
      padding-right: 0;
      color: #595959;
      line-height: 1;
      border: none;
    }
  }
  &__list {
    position: relative;
    display: flex;
    margin-top: 16px;
    background: #ffffff;
  }
}
</style>
